import { fetchPart, fetchPartType } from '@/services/api';
import { fetchDivisionOptions } from '@/services/division';
import { sortByStr } from '@/utils/utils';

export default {
  namespace: 'part',

  state: {
    parts: [],
    partType: [],
    divisionOptions: [],
  },

  effects: {
    *getParts({ payload, callback }, { call, put }) {
      const response = yield call(fetchPart, payload);
      yield put({
        type: 'saveParts',
        payload: response,
      });
      if (callback) callback();
    },

    *getPartType({ payload }, { call, put }) {
      const response = yield call(fetchPartType, payload);
      yield put({
        type: 'savePartType',
        payload: response,
      });
    },
    *getDivisionOptions({ payload }, { call, put }) {
      const response = yield call(fetchDivisionOptions, payload);
      yield put({
        type: 'saveDivisionOptions',
        payload: response,
      });
    },
  },
  reducers: {
    saveParts(state, action) {
      const data = action.payload;
      return {
        ...state,
        parts: data,
      };
    },
    savePartType(state, action) {
      const { data } = action.payload;
      return {
        ...state,
        partType: data || [],
      };
    },
    saveDivisionOptions(state, action) {
      return {
        ...state,
        divisionOptions: action?.payload?.data?.sort?.(sortByStr('name')) || [],
      };
    },
  },
};
